import { forwardRef } from 'react';

import {
  Left,
  PriceEmail,
  PricePhone,
  PriceText,
  PriceTitle,
  Right,
  Wrapper,
} from './styled';

const EMAIL = 'support@aplodesk.ru';
const PHONE_NUMBER = '';

export const SupportBlock = forwardRef<HTMLDivElement>(() => {
  return (
    <Wrapper>
      <Left>
        <PriceTitle>Служба технической поддержки</PriceTitle>
        <PriceText>
          Наша команда предоставляет техническую поддержку для всех клиентов, которые
          используют программное обеспечение «AploCast».
        </PriceText>
      </Left>
      <Right>
        <PriceEmail href={`mailto:${EMAIL}`}>{EMAIL}</PriceEmail>
        <PricePhone>{PHONE_NUMBER}</PricePhone>
      </Right>
    </Wrapper>
  );
});
